import React from 'react';
import { useTranslation } from 'react-i18next';

import './MoveIcon.scss';

interface Props {
  clickHandler: () => void;
  active: boolean;
  imgSrc: string;
  alt: string;
  text: string;
  disabledHover?: boolean;
  hide?: boolean;
}

export const NewMoveIcon = ({
  clickHandler,
  active,
  disabledHover,
  hide,
  text,
  imgSrc,
  alt,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div
      className={`transition-all duration-300 rounded-[8px] sm:rounded-[14px] xlg:rounded-[18px] p-[2px] ${disabledHover ? '' : 'cursor-pointer'}`}
      onClick={clickHandler}
      style={{
        background: active
          ? 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(79, 181, 255, 1) 100%)'
          : 'linear-gradient(180deg,rgba(50, 46, 102, 1) 0%,rgba(55, 52, 112, 1) 100%)',
      }}
    >
      <div
        className="transition-all duration-300 rounded-[8px] sm:rounded-[14px] xlg:rounded-[18px] flex flex-col gap-4 sm:gap-[22px] xlg:gap-[30px] items-center justify-end shrink-0 w-[62px] h-[84px] sm:w-[96px] sm:h-[128px] xlg:w-[120px] xlg:h-[160px] relative overflow-hidden"
        style={{
          background: active
            ? 'linear-gradient(180deg, rgba(13, 20, 80, 1) 0%, rgba(23, 33, 120, 1) 100%)'
            : 'linear-gradient(180deg, rgba(21, 23, 40, 1) 0%,rgba(29, 33, 62, 1) 100%)',
        }}
      >
        <div className="shrink-0 w-[36px] h-[30px] sm:w-[56px] sm:h-[48px] xlg:w-[70px]  xlg:h-[60px] relative">
          <img
            className={`transition-all duration-300 w-[100%] h-[100%] absolute right-[0%] left-[0%] bottom-[0%] top-[0%] ${active ? '' : 'opacity-50'}`}
            style={{ objectFit: 'cover' }}
            src={imgSrc}
            alt={t(text)}
          />
        </div>
        <div
          className={`transition-all duration-300 rounded-br-[8px] rounded-bl-[8px] sm:rounded-br-[14px] sm:rounded-bl-[14px] xlg:rounded-br-[18px] xlg:rounded-bl-[18px] ${active ? 'border-[#75c5ff]' : 'border-border'} border-t-2 pt-3 pr-6 pb-3 pl-6 flex flex-row gap-2 items-center justify-center self-stretch shrink-0 h-[18px] sm:h-9 relative overflow-hidden`}
          style={{
            background: active
              ? 'linear-gradient(-67.96deg, rgba(40, 35, 120, 1) 0%, rgba(12, 9, 61, 1) 100%)'
              : 'linear-gradient(-67.96deg, rgba(55, 52, 112, 1) 0%,rgba(28, 26, 66, 1) 100%)',
          }}
        >
          <div
            className={`${active ? 'text-white font-semibold' : 'text-white/50'} transition-all duration-300 text-center text-[10px] leading-[10px]  sm:text-xl  sm:leading-5  relative flex items-center justify-center`}
          >
            {t(text)}
          </div>
        </div>
      </div>
    </div>
  );
};
